// extracted by mini-css-extract-plugin
export default {"icon":"PastilleIcon_icon__Zwi0b","pulse":"PastilleIcon_pulse__IIo5z"};